
import { defineComponent, ref } from "vue";
import { required, maxLength } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import ToolTip from "@/components/common/ToolTip.vue";
import routesPath from "@/config/routesPath";
import * as apiClient from "@/apiclient/";
import TokenService from "@/services/tokenService";
import messages from "@/config/messages";
import common from "@/config/common";
import { mapGetters } from "vuex";

interface UserData {
  ssn: string;
  zip: string;
  dob: string;
  lastName: string;
  fullName: string;
  userName: string;
  password: string;
  passwordConfirmation: string;
  email: string;
  securityQuestion: string;
  securityAnswer: string;
}

export default defineComponent({
  name: "CreateAccount",
  components: {
    ToolTip,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      user: {
        ssn: "",
        zip: "",
        dob: "",
        lastName: "",
        fullName: "",
        userName: "",
        password: "",
        passwordConfirmation: "",
        email: "",
        securityQuestion: "",
        securityAnswer: "",
      } as UserData,

      submitted: false,
      isFormInvalid: false,
      validationMsg: "",
      isSubmitDisabled: false,
      messages,
      routesPath,
      challengeToken: "",
      rememberDevice: false,
    };
  },
  validations() {
    return {
      user: {
        securityAnswer: {
          ...{
            required,
            maxLength: maxLength(128),
          },
        },
      },
    };
  },
  mounted() {
    this.user.securityQuestion = sessionStorage.getItem(
      common.storageVariables.challengeQuestion
    )!;
    this.challengeToken = TokenService.getToken("ChallengeToken")!;
  },
  computed: {
    ...mapGetters(["getAutoLogoutMsg"]),
  },
  methods: {
    hideErrors(field: string): void {
      this.v$.user[field].$touch();
      this.isFormInvalid = false;
    },
    backButtonHandler() {
      this.isFormInvalid = false;
      this.$router.push({
        path: routesPath.base,
      });
    },
    buttonDesign(): string {
      const buttonStatus = this.v$.user.$invalid;
      return buttonStatus == true ? "btn-secondary w-80" : "btn-primary w-80";
    },
    async handleSubmit() {
      this.submit();
    },
    async submit(): Promise<void> {
      this.isFormInvalid = false;
      this.submitted = true;
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }
      const params = {
        challengeAnswer: this.user.securityAnswer,
        rememberDevice: this.rememberDevice,
      };
      this.isSubmitDisabled = true;
      const result = await apiClient
        .deviceChallengeController()
        .postApiDevicechallengeValidatedevicechallenge(params, {
          headers: { Authorization: "Bearer " + this.challengeToken },
        });

      this.isSubmitDisabled = false;
      console.log(JSON.stringify(result.data));

      if (!result || result.error) {
        this.isFormInvalid = true;
        if (result.error) {
          this.validationMsg = result.error + messages.errorMsg;
        }
        return;
      } else if (result.data?.valid) {
        const token: string = result.data?.participantToken?.token || "";
        const refreshToken: string =
          result.data?.participantToken?.refreshToken || "";

        TokenService.setToken("ParticipantToken", token);
        TokenService.setAccessToken(token);
        TokenService.setRefreshToken(refreshToken);

        this.$router.push({ name: routesPath.enrollments });
        return;
      } else {
        this.isFormInvalid = true;
        const message: string = result.data?.message || "";
        this.validationMsg = message + messages.errorMsg;
        return;
      }
    },
  },
});
